export enum AnalyticOrganizationEnum {
  STRUCTURE = 'STRUCTURE',
  LAYOUT = 'LAYOUT',
}
